// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "web-worker/" + ({"622":"members-v3-follow","975":"ricos-content-utils"}[chunkId] || chunkId) + ".chunk.min.js";
};